module.exports = __webpack_public_path__ + "panel1fr.png?a795037c56cf2b77240485a516563d95";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/panel1fr.png
// module id = 57
// module chunks = 0